import { Navigate, useLocation } from 'react-router-dom'
import { useIsAuthenticated, useBusiness } from '@/stores/auth'
import { ROUTES } from '@/config/routes'
import { BusinessOnboardingPage } from '@/pages/BusinessOnboardingPage'
import { TeamContextGuard } from './TeamContextGuard'

interface ProtectedRouteProps {
  children: React.ReactNode
  /**
   * If true, skip team context check (for routes like team selection page)
   */
  skipTeamContext?: boolean
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  skipTeamContext = false,
}) => {
  const isAuthenticated = useIsAuthenticated()
  const business = useBusiness()
  const location = useLocation()

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  // Check if user needs onboarding
  if (business && !business.is_onboarded) {
    return <BusinessOnboardingPage />
  }

  // Skip team context guard if specified (e.g., for team selection page)
  if (skipTeamContext) {
    return <>{children}</>
  }

  // Wrap with TeamContextGuard to ensure team is selected
  return <TeamContextGuard>{children}</TeamContextGuard>
}